/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Link } from 'gatsby'

const Navigation = ({ storeEnabled, style: styleProp }) => {
  return (
    <nav sx={{ ...styleProp }}>
      <ul
        className="heading"
        sx={{
          fontSize: [44, 60],
          lineHeight: ['60px', '80px']
        }}
      >
        <li>
          <Link to="/restaurant" className="link link-underline">
            Restaurant
          </Link>
        </li>
        <li>
          <Link to="/cellar" className="link link-underline">
            Cellar
          </Link>
        </li>
        {storeEnabled && (
          <li>
            <Link to="/store" className="link link-underline">
              Store
            </Link>
          </li>
        )}
        <li>
          <Link to="/events" className="link link-underline">
            Events
          </Link>
        </li>
        <li>
          <Link to="/journal" className="link link-underline">
            Journal
          </Link>
        </li>
      </ul>
    </nav>
  )
}

export default Navigation
